export const vipCancelFromEmailPath = '/vip/cancel_confirm'
